export default "__VITE_ASSET__YJVx0Fma__"